/* MUTE Recently-Viewed — Phase 6.3 (2026-06-15)
   localStorage 'mute_recently_viewed_v1' (max 10, dedupe by handle, neuste zuerst).
   Aufzeichnung: liest #mute-rv-current (JSON, nur auf PDP).
   Anzeige: rendert in #mute-rv-root (PDP + Homepage), aktuelles Produkt ausgeschlossen.
   Self-styling, idempotent, 0 CLS (aspect-ratio reserviert). */
(function () {
  'use strict';
  if (window.MuteRecentlyViewed) return;

  var KEY = 'mute_recently_viewed_v1';
  var MAX = 10;
  var SHOW = 8;
  var STYLE_ID = 'mute-rv-style';

  function read() {
    try { var a = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(a) ? a : []; }
    catch (e) { return []; }
  }
  function write(a) {
    try { localStorage.setItem(KEY, JSON.stringify(a.slice(0, MAX))); } catch (e) {}
  }

  function record(item) {
    if (!item || !item.handle) return;
    var a = read().filter(function (x) { return x && x.handle !== item.handle; });
    a.unshift(item);
    write(a);
  }

  function euro(cents) {
    if (typeof cents !== 'number') return '';
    try { return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }); }
    catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  }

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var css =
      '.mute-rv{padding:clamp(28px,5vw,52px) clamp(16px,4vw,32px);}' +
      '.mute-rv__inner{max-width:1200px;margin:0 auto;}' +
      '.mute-rv__eyebrow{margin:0 0 4px;font-family:var(--mute-font-mono,monospace);font-size:11px;letter-spacing:.14em;text-transform:uppercase;color:var(--mute-text-meta,#595959);}' +
      '.mute-rv__title{margin:0 0 clamp(14px,2.5vw,22px);font-family:var(--mute-font-display,sans-serif);font-weight:800;line-height:1.1;font-size:clamp(20px,2.6vw,30px);color:var(--mute-text-primary,#0A0A0A);}' +
      '.mute-rv__rail{display:grid;grid-template-columns:repeat(auto-fill,minmax(min(150px,46%),1fr));gap:clamp(10px,2vw,18px);}' +
      '.mute-rv__card{display:flex;flex-direction:column;min-width:0;text-decoration:none;}' +
      '.mute-rv__media{display:block;aspect-ratio:1/1;background:var(--mute-bg-warm,#FAF8F3);border:1px solid var(--mute-border,#E8E3D8);overflow:hidden;}' +
      '.mute-rv__media img{width:100%;height:100%;object-fit:cover;display:block;}' +
      '.mute-rv__name{margin:8px 0 2px;font-family:var(--mute-font-body,sans-serif);font-size:clamp(13px,1.5vw,15px);line-height:1.3;color:var(--mute-text-primary,#0A0A0A);overflow-wrap:anywhere;}' +
      '.mute-rv__price{margin:0;font-family:var(--mute-font-body,sans-serif);font-size:clamp(13px,1.5vw,15px);font-weight:700;color:var(--mute-text-primary,#0A0A0A);}' +
      '.mute-rv__card:hover .mute-rv__name{color:var(--mute-signal-red-text,#C8341A);}';
    var st = document.createElement('style');
    st.id = STYLE_ID;
    st.textContent = css;
    document.head.appendChild(st);
  }

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function render(root) {
    var excludeHandle = root.getAttribute('data-mute-rv-exclude') || '';
    var items = read().filter(function (x) { return x && x.handle && x.handle !== excludeHandle; }).slice(0, SHOW);
    if (items.length < 2) { root.style.display = 'none'; return; }
    injectStyle();
    var cards = items.map(function (x) {
      var img = x.image ? '<span class="mute-rv__media"><img src="' + esc(x.image) + '" alt="' + esc(x.title) + '" loading="lazy" decoding="async" width="300" height="300"></span>' : '<span class="mute-rv__media"></span>';
      return '<a class="mute-rv__card" href="' + esc(x.url) + '">' + img +
        '<span class="mute-rv__name">' + esc(x.title) + '</span>' +
        (typeof x.price === 'number' ? '<span class="mute-rv__price">' + euro(x.price) + '</span>' : '') +
        '</a>';
    }).join('');
    root.innerHTML =
      '<div class="mute-rv__inner">' +
      '<p class="mute-rv__eyebrow">Zuletzt begutachtet</p>' +
      '<h2 class="mute-rv__title">' + (root.getAttribute('data-mute-rv-heading') || 'Wieder reingeschaut. Der Schreibtisch ruft leider immer noch.') + '</h2>' +
      '<div class="mute-rv__rail">' + cards + '</div>' +
      '</div>';
    root.style.display = '';
  }

  function init() {
    var cur = document.getElementById('mute-rv-current');
    if (cur) {
      try { record(JSON.parse(cur.textContent)); } catch (e) {}
    }
    var root = document.getElementById('mute-rv-root');
    if (root) render(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.MuteRecentlyViewed = { record: record, read: read };
})();
